import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { markActionAsCompleted } from './api';
import { QueryKey } from '../QueryKey';
import { goToErrorPage } from 'utils';

export default function useMarkActionAsCompleted() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate } = useMutation((actionId: number) => markActionAsCompleted(actionId), {
    onError: (error: any) => {
      goToErrorPage(error);
      toast.error(t('message.title.error.action.mark.as.completed'));
    },
    onSuccess: data => {
      queryClient.invalidateQueries([QueryKey.ACTION, data.id]);
      queryClient.invalidateQueries([QueryKey.ACTION_ALL]);
    },
  });

  return mutate;
}
